import { render } from "./PaiementMethode.vue?vue&type=template&id=6cb631fa&scoped=true&ts=true"
import script from "./PaiementMethode.vue?vue&type=script&lang=ts"
export * from "./PaiementMethode.vue?vue&type=script&lang=ts"

import "./PaiementMethode.vue?vue&type=style&index=0&id=6cb631fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb631fa"]])

export default __exports__